import { render, staticRenderFns } from "./GripVerticalIcon.vue?vue&type=template&id=60da9871"
import script from "./GripVerticalIcon.vue?vue&type=script&lang=js"
export * from "./GripVerticalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports